import PlaceholderImage from '@assets/images/img-final-home-03.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './BrandSafetyOne.style';
import { useTranslation } from 'react-i18next';

const BrandSafetyOne = () => {
  const { t } = useTranslation('brandSafety');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('brandSafetyOne.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox2>
          <p>
            {t('brandSafetyOne.paragraphOne')}
            <br />
            <br /> {t('brandSafetyOne.paragraphTwo')}
            <br />
            <br />
            {t('brandSafetyOne.paragraphThree')}
          </p>
        </TextBox2>
        <ImageBox>
          <img src={PlaceholderImage} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default BrandSafetyOne;
